export const search_ru = {
    text: 'Наш поиск поможет найти быстрее',
    input_text: 'Введите название организации',
    searchbtn: 'Найти',
    select_text: 'Все группы продукций'
}